import { Routes } from '@angular/router';
import { UniversitySearchComponent } from './views/university-search/university-search.component';
import { ClearingUniversitySearchComponent } from './views/clearing-university-search/clearing-university-search.component';
import { validateProductGuard } from './guards/validate-product.guard';

export const UNIVERSITIES_ROUTES: Routes = [
	{ path: '', redirectTo: 'undergraduate', pathMatch: 'full' },
	{
		path: '',
		children: [
			{ path: 'clearing', component: ClearingUniversitySearchComponent },
			{
				path: ':product',
				component: UniversitySearchComponent,
				canMatch: [validateProductGuard],
			},
		],
	},
];
